/* Bcustom - traduzione in italiano dei testi delle app opzioni (Hulk, YMQ) e del bundle */
(function () {
  var rules = [
    [/^\s*Please choose\s*$/i, 'Seleziona'],
    [/^\s*Please select\s*$/i, 'Seleziona'],
    [/^\s*Choose File\s*$/i, 'Scegli file'],
    [/^\s*No file chosen\.*\s*$/i, 'Nessun file selezionato'],
    [/^\s*Choose\s+(.+)$/i, 'Scegli $1'],
    [/^\s*Select\s+(.+)$/i, 'Seleziona $1'],
    [/^\s*Upload\s*$/i, 'Carica'],
    [/You save/g, 'Risparmi'],
    [/^\s*Buy\s+(\d+)\s*$/i, 'Acquista $1'],
    [/^\s*This field is required\.?\s*$/i, 'Campo obbligatorio'],
    [/^\s*Required\s*$/i, 'Obbligatorio']
  ];
  var scope = '.product-form, #ymq-box, .hulkapps_product_options, quantity-breaks, .quantity-breaks, [class*="quantity-break"], .product__info-container, .sticky-atc';

  function tr(s) {
    if (!s) return s;
    for (var i = 0; i < rules.length; i++) {
      if (rules[i][0].test(s)) {
        rules[i][0].lastIndex = 0;
        return s.replace(rules[i][0], rules[i][1]);
      }
    }
    return s;
  }

  function run(root) {
    var areas = (root && root.querySelectorAll) ? root.querySelectorAll(scope) : [];
    var list = Array.prototype.slice.call(areas);
    list.forEach(function (area) {
      var w = document.createTreeWalker(area, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var t = tr(n.nodeValue);
        if (t !== n.nodeValue) n.nodeValue = t;
      }
      area.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
        var p = tr(el.getAttribute('placeholder'));
        if (p !== el.getAttribute('placeholder')) el.setAttribute('placeholder', p);
      });
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { run(document); }, 60); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
  else run(document);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
